/**
 * Global application field template codes used in custom reports and filtering
 */
export class GlobalApplicationFields {
  static readonly APPLICATION_NUMBER = 'APPLICATION_NUMBER';
  static readonly CURRENT_ACTIVITY = 'CURRENT_ACTIVITY';
  static readonly USER_IS_RESPONSIBLE_FOR_A_CURRENT_ACTIVITY = 'USER_IS_RESPONSIBLE_FOR_A_CURRENT_ACTIVITY';
  static readonly APPLICATION_ID = 'APPLICATION_ID';
  static readonly COLLECTED_BY = 'COLLECTED_BY';
  static readonly TOTAL_FEES_PAID_NUM = 'TOTAL_FEES_PAID_NUM';
  static readonly TOTAL_FEES_PAID = 'TOTAL_FEES_PAID';
  static readonly TOTAL_FEES_DUE = 'TOTAL_FEES_DUE';
  static readonly TOTAL_FEES_DUE_NUM = 'TOTAL_FEES_DUE_NUM';
  static readonly PARENT_APPLICATION_STATUS = 'PARENT_APPLICATION_STATUS';
  static readonly WORKFLOW_NAME = 'WORKFLOW_NAME';
  static readonly WORKFLOW_ID = 'WORKFLOW_ID';
  static readonly PERMIT_DESCRIPTION = 'PERMIT_DESCRIPTION';
  static readonly SUBMITTER = 'SUBMITTER';
  static readonly CREATE_DATE = 'CreateDate';
  static readonly APPLICATION_STATUS = 'APPLICATION_STATUS';
  static readonly PAYMENT_METHOD = 'PAYMENT_METHOD';
  static readonly TOTAL_FEES_NUM = 'TOTAL_FEES_NUM';
  static readonly ALL_FEE_RECIPIENTS = 'ALL_FEE_RECIPIENTS';
  static readonly DEPARTMENT_ID = 'DEPARTMENT_ID';
  static readonly MESSAGES = 'messages';
  static readonly DOCUMENTS_TO_REVIEW = 'DocumentsToReview';
  static readonly TOTAL_DOCUMENT_COUNT = 'TotalDocumentCount';
  static readonly APPLICATION_SUBMITTED_ON = 'ApplicationSubmittedOn';
  static readonly ISSUED_ON = 'IssuedOn';
  static readonly APPLICATION_NOTES_COUNT = 'ApplicationNotesCount';
  static readonly ASSIGNED_SIGN_OFFS_COUNT = 'AssignedSignOffsCount';
  static readonly APPROVED_SIGN_OFFS_COUNT = 'ApprovedSignOffsCount';
  static readonly DISAPPROVED_SIGN_OFFS_COUNT = 'DisapprovedSignOffsCount';
  static readonly INSPECTIONS_COUNT = 'InspectionsCount';
  static readonly APPLICANT_SUBMITTED = 'ApplicantSubmitted';
  static readonly ASSIGNED_INSPECTIONS_COUNT = 'AssignedInspectionsCount';
  static readonly APPROVED_INSPECTIONS_COUNT = 'ApprovedInspectionsCount';
  static readonly DISAPPROVED_INSPECTIONS_COUNT = 'DisapprovedInspectionsCount';
  static readonly CURRENT_ACTIVITY_JSON = 'CURRENT_ACTIVITY_JSON';

  /**
   * Returns all global application field template codes
   */
  static getAll(): string[] {
    return [
      GlobalApplicationFields.APPLICATION_NUMBER,
      GlobalApplicationFields.CURRENT_ACTIVITY,
      GlobalApplicationFields.USER_IS_RESPONSIBLE_FOR_A_CURRENT_ACTIVITY,
      GlobalApplicationFields.APPLICATION_ID,
      GlobalApplicationFields.COLLECTED_BY,
      GlobalApplicationFields.TOTAL_FEES_PAID_NUM,
      GlobalApplicationFields.TOTAL_FEES_PAID,
      GlobalApplicationFields.TOTAL_FEES_DUE,
      GlobalApplicationFields.TOTAL_FEES_DUE_NUM,
      GlobalApplicationFields.PARENT_APPLICATION_STATUS,
      GlobalApplicationFields.WORKFLOW_NAME,
      GlobalApplicationFields.WORKFLOW_ID,
      GlobalApplicationFields.PERMIT_DESCRIPTION,
      GlobalApplicationFields.SUBMITTER,
      GlobalApplicationFields.CREATE_DATE,
      GlobalApplicationFields.APPLICATION_STATUS,
      GlobalApplicationFields.PAYMENT_METHOD,
      GlobalApplicationFields.TOTAL_FEES_NUM,
      GlobalApplicationFields.ALL_FEE_RECIPIENTS,
      GlobalApplicationFields.DEPARTMENT_ID,
      GlobalApplicationFields.MESSAGES,
      GlobalApplicationFields.DOCUMENTS_TO_REVIEW,
      GlobalApplicationFields.TOTAL_DOCUMENT_COUNT,
      GlobalApplicationFields.APPLICATION_SUBMITTED_ON,
      GlobalApplicationFields.ISSUED_ON,
      GlobalApplicationFields.APPLICATION_NOTES_COUNT,
      GlobalApplicationFields.ASSIGNED_SIGN_OFFS_COUNT,
      GlobalApplicationFields.APPROVED_SIGN_OFFS_COUNT,
      GlobalApplicationFields.DISAPPROVED_SIGN_OFFS_COUNT,
      GlobalApplicationFields.INSPECTIONS_COUNT,
      GlobalApplicationFields.APPLICANT_SUBMITTED,
      GlobalApplicationFields.ASSIGNED_INSPECTIONS_COUNT,
      GlobalApplicationFields.APPROVED_INSPECTIONS_COUNT,
      GlobalApplicationFields.DISAPPROVED_INSPECTIONS_COUNT,
      GlobalApplicationFields.CURRENT_ACTIVITY_JSON
    ];
  }
}
